import { render, staticRenderFns } from "./IntentFeatures.vue?vue&type=template&id=0aba470a&scoped=true"
import script from "./IntentFeatures.vue?vue&type=script&lang=js"
export * from "./IntentFeatures.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0aba470a",
  null
  
)

export default component.exports